import type { SWRConfiguration } from 'swr';

export const swrConfig: SWRConfiguration = {
  revalidateOnFocus: false,
  revalidateOnReconnect: true,
  dedupingInterval: 10000,
  refreshInterval: 300000,
  errorRetryCount: 3,
  errorRetryInterval: 5000,
};

/**
 * Canonical SWR cache key helpers — use these everywhere so that
 * the fallback data seeded in _app.tsx always matches the hook keys.
 * Keys follow the /api/directus URL format used by useDirectus.ts hooks.
 */
export const CACHE_KEYS = {
  page: (slug: string) => `/api/directus/pages?slug=${encodeURIComponent(slug)}`,
  blogPosts: (page: number, perPage: number) => `/api/directus/blog_posts?page=${page}&per_page=${perPage}`,
  blogPost: (slug: string) => `/api/directus/blog_posts?slug=${encodeURIComponent(slug)}`,
  galleryCategories: () => '/api/directus/gallery_categories',
} as const;
